import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header skin-card-header text-start d-flex align-items-center justify-content-between" }
const _hoisted_2 = {
  key: 0,
  class: "float-end"
}
const _hoisted_3 = { class: "card-body skin-card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help = _resolveComponent("help")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card skin-card shadow-sm mx-auto mb-5 mt-0", _ctx.cardClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      (_ctx.showHelp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_help, {
              title: _ctx.helpTitle,
              text: _ctx.helpText,
              color: _ctx.getPanelHeadingHelpColor()
            }, null, 8, ["title", "text", "color"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "footer")
    ])
  ], 2))
}